"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../../scss/cookieConsentModalFooter.scss");
const react_1 = __importDefault(require("react"));
const cookieConsentShowModalType_1 = require("../../models/cookieConsentShowModalType");
const useService_1 = require("../../hooks/useService");
const useCookiesConsent_1 = require("../../hooks/useCookiesConsent");
const useMobileDetect_1 = __importDefault(require("../../hooks/useMobileDetect"));
function CookieConsentModalFooter() {
    var _a, _b;
    const { config, intlLang, setCookieConsentShowModal, setCookieConsentPreferences } = (0, useCookiesConsent_1.useCookiesConsent)();
    const cookieService = (0, useService_1.useService)("CookieService");
    const isMobile = (0, useMobileDetect_1.default)().isMobile();
    const onPersonalize = () => {
        setCookieConsentShowModal(cookieConsentShowModalType_1.CookieConsentShowModalType.FULL);
    };
    const onAcceptAll = () => {
        const allTrueCookieConsentPreferences = {
            necessary: true,
            functionality: true,
            analytics: true,
            advertising: true,
        };
        cookieService.setCookieConsentPreferences(allTrueCookieConsentPreferences);
        setCookieConsentPreferences(allTrueCookieConsentPreferences);
        setCookieConsentShowModal(cookieConsentShowModalType_1.CookieConsentShowModalType.HIDE_ALL);
    };
    return (react_1.default.createElement("div", { className: "cookie-consent-modal-footer" },
        react_1.default.createElement("div", { className: `cookie-consent-modal-btn-wrapper ${isMobile && "mobile"}` },
            react_1.default.createElement("button", { className: `cookie-consent-modal-btn ${isMobile && "mobile"}`, onClick: onPersonalize }, (_a = config.innerButtonPersonalized) === null || _a === void 0 ? void 0 : _a[intlLang]),
            react_1.default.createElement("button", { className: `cookie-consent-modal-btn all ${isMobile && "mobile"}`, onClick: onAcceptAll }, (_b = config.innerButtonAcceptAll) === null || _b === void 0 ? void 0 : _b[intlLang]))));
}
exports.default = CookieConsentModalFooter;
//# sourceMappingURL=CookieConsentModalFooter.js.map